import { TextFieldElement } from 'react-hook-form-mui';

type MaximumNumberOfConcurrentUsersFieldProps = {
    name: string;
    disabled?: boolean;
    required?: boolean;
};

export function MaximumNumberOfConcurrentUsersField({
    name,
    disabled = false,
    required = false,
}: MaximumNumberOfConcurrentUsersFieldProps) {
    return (
        <TextFieldElement
            label="Maximum Number of Concurrent Users  (Empty for no limit)"
            name={name}
            type="number"
            placeholder="unlimited"
            slotProps={{
                htmlInput: { min: '1', step: '1' },
                inputLabel: { shrink: true },
            }}
            disabled={disabled}
            rules={{
                min: { value: 1, message: 'Please enter a positive number' },
            }}
            required={required}
            autoComplete="off"
            variant="outlined"
        />
    );
}
